<template>
  <BModal
    id="modal-change-phone"
    centered
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    hide-footer
    hide-header
    @shown="validateOldPhone"
  >
    <div class="my-2 mx-1">
      <div class="text-center mb-2">
        <div class="font-semibold text-2xl text-black mb-1">
          Ubah Nomor HP
        </div>
        <div>Demi keamanan, pengguna diharuskan memperbarui nomor Hp yang bisa dihubungi secara berkala</div>
      </div>
      <div class="mb-1">
        <div class="mb-1">
          Nomor HP Lama
        </div>
        <b-input-group>
          <template #prepend>
            <b-form-input
              v-model="phoneCode"
              style="background-color: #f4f4f4; width: 5rem;"
              disabled
            />
          </template>
          <b-form-input
            id="phoneNumbers"
            v-model="oldCustomerPhone"
            disabled
          />
        </b-input-group>
      </div>
      <div class="mb-1">
        <div class="mb-1">
          Nomor HP Baru
        </div>
        <b-input-group>
          <template #prepend>
            <b-form-input
              v-model="phoneCode"
              style="background-color: #f4f4f4; width: 5rem;"
              disabled
            />
          </template>
          <b-form-input
            id="phoneNumbers"
            v-model="newCustomerPhone"
            type="number"
            :class="
              requireCustomerPhone
                ? 'bg-[#FFEDED] border-[1px] border-[#E31A1A]'
                : 'bg-[ffffff]'
            "
            :formatter="validatePhone"
            @paste.prevent="handlePaste"
            @keypress="blockCharacter($event)"
          />
        </b-input-group>
        <div v-if="messageError !== ''">
          <small class="mr-1 text-primary">
            *{{ messageError }}
          </small>
        </div>
        <div
          v-if="whatsappStatus !== null"
          :class="['d-flex', whatsappStatus.textColor]"
          style="margin-top: 5px;"
        >
          <span
            class="k-Whatsapp text-[22px]"
          />
          <span
            class="my-auto"
            style="margin-left: 0.2vw;font-size:12px"
          >{{ whatsappStatus.message }}</span>
        </div>
      </div>
      <div class="mb-2">
        <div class="mb-1 d-flex">
          <span>Dokumen Pendukung</span>
          <span class="text-danger">*</span>
          <span
            v-b-tooltip.hover="'Berisi bukti dari user yang telah disetujui oleh Ops'"
            class="k-info-circle-1 ml-[5px] text-[#08A0F7] align-self-center"
          />
        </div>
        <b-form-input
          v-model="fieldSupportingDoc"
          placeholder="Link dokumen pendukung"
          class="pr-2"
        />
        <div class="text-sm mt-[5px]">
          <span class="text-danger">*</span>
          <span>Wajib, diisi. Berisi tentang bukti-bukti dari user yang telah disetujui oleh Ops</span>
        </div>
      </div>
    </div>
    <div class="w-full d-flex justify-center gap-4 pb-2 py-1">
      <b-button
        class="flex-[45%]"
        variant="outline-primary"
        @click="resetCondition()"
      >
        Batal
      </b-button>
      <b-button
        class="flex-[45%]"
        :variant="messageError !== '' || newCustomerPhone === '' || fieldSupportingDoc.length < 10 ? 'secondary' : 'primary'"
        :disabled="messageError !== '' || newCustomerPhone === '' || fieldSupportingDoc.length < 5"
        @click="updatePhone()"
      >
        Simpan
      </b-button>
    </div>
  </BModal>
</template>

<script>
export default {
  props: {
    valuePhone: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      phoneCode: '+62',
      phoneCodeList: ['+62'],
      oldCustomerPhone: '',
      newCustomerPhone: '',
      fieldSupportingDoc: '',
      requireCustomerPhone: null,
      messageError: '',
      isWhatsapp: null,
    }
  },
  computed: {
    whatsappStatus() {
      if (this.isWhatsapp === 'valid') {
        return {
          message: 'Nomor ini terhubung ke Whatsapp',
          content: 'Kurir akan lebih mudah berkoordinasi',
          textColor: 'text-[#34A770]',
        }
      } if (this.isWhatsapp === 'invalid') {
        return {
          message: 'Nomor ini tidak terhubung ke Whatsapp',
          content: 'Kurir akan kesulitan dalam berkoordinasi',
          textColor: 'text-[#E31A1A]',
        }
      } if (this.isWhatsapp !== null) {
        return {
          message: 'Maaf, terdapat masalah saat melakukan cek nomor',
          content: '',
          textColor: 'text-[#FBA63C]',
        }
      }
      return null
    },
  },
  methods: {
    updatePhone() {
      const value = {
        phone_number: this.newCustomerPhone,
        supporting_link: this.fieldSupportingDoc,
      }
      this.$emit('on-confirm-button', value)
      this.resetCondition()
    },
    resetCondition() {
      this.newCustomerPhone = ''
      this.fieldSupportingDoc = ''
      this.messageError = ''
      this.requireCustomerPhone = null
      this.isWhatsapp = null
      this.$bvModal.hide('modal-change-phone')
    },
    validateOldPhone() {
      if (this.valuePhone.length > 9) {
        let phone = this.valuePhone
        const startsWithEight = this.valuePhone.startsWith('8')
        if (!startsWithEight) {
          phone = this.valuePhone.slice(1)
        }
        this.oldCustomerPhone = this.validatePhone(phone)
      }
    },
    validatePhone(value) {
      if (this.newCustomerPhone !== value) {
        this.messageError = ''
        this.isWhatsapp = null
        const phone = value.replace(/[^\d]/g, '')
        const startsWithEight = phone.startsWith('8')
        const isRequired = phone.length === 0
        this.requireCustomerPhone = phone.length < 9 || phone.length > 15 || !startsWithEight || isRequired

        if (isRequired) {
          this.messageError = 'Wajib diisi ya'
          return value
        }

        if (value.startsWith('62')) {
          return value.slice(2)
        }

        if (!startsWithEight) {
          this.messageError = 'Wajib di mulai angka 8'
          return value.slice(1)
        }

        if (phone.length < 9) {
          this.messageError = 'Minimal 9 angka'
        }

        if (phone.length > 15) {
          this.messageError = 'Maksimal 15 karakter'
          return value.substring(0, 15)
        }

        if (!this.requireCustomerPhone && this.newCustomerPhone.length > 9) {
          this.requireCustomerPhone = true
          this.checkPhoneUsed()
        }
      }
      return value
    },
    handlePaste(event) {
      const pasteContent = (
        event.clipboardData || window.clipboardData
      ).getData('text')
      const sanitizedContent = pasteContent.replace(/\D/g, '')
      this.newCustomerPhone = sanitizedContent
      const index = this.newCustomerPhone.indexOf('8')
      if (index !== -1) {
        const secondPart = this.newCustomerPhone.substring(index)
        this.newCustomerPhone = `${secondPart}`
      }
      event.preventDefault()
    },
    blockCharacter($event) {
      this.messageError = ''
      const key = ['e', '+', '.', '-', ',']
      if (key.includes($event.key)) {
        $event.preventDefault()
      } else {
        this.validatePhone($event.target.value)
      }
    },
    checkPhoneUsed: _.debounce(async function () {
      await this.$http_new
        .get(
          `/auth/api/v1/user/setting/phone/check-used?phone=62${this.newCustomerPhone}`,
        )
        .then(response => {
          const { data } = response.data
          if (data.is_used) {
            this.messageError = 'Nomor Hp sudah digunakan orang lain'
            this.requireCustomerPhone = true
          } else {
            this.checkWhatsapp()
          }
          this.requireCustomerPhone = false
        })
        .catch(err => {
          this.$toast_error({ message: 'Gagal melakukan pengecekan nomor' })
        })
    }, 1000),
    checkWhatsapp: _.debounce(async function () {
      if (String(this.newCustomerPhone).length >= 9) {
        await this.$http_komship.post(`/v1/check-wa?phone_no=${this.newCustomerPhone}`)
          .then(res => {
            this.isWhatsapp = res.status === 200 ? 'valid' : null
          })
          .catch(error => {
            this.isWhatsapp = error.response.status === 400 ? 'invalid' : ''
          })
      } else {
        this.isWhatsapp = null
      }
    }, 500),
  },
}
</script>
